import React from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { Box, Grid, Typography } from '@mui/material'
import { useGetCustomerQuery } from 'services/customers'
import { PAYMENT_METHODS_VALUES } from 'utils/constants'
import { formatNumber } from 'utils/helpers'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import usePaymentTerms from 'utils/custom-hooks/usePaymentTerms'
import { useCustomerHeader } from '../account/utils'

const CustomerFinancialInformationField = ({ title, value }) => (
  <Grid item xs={1.5}>
    <Typography variant="caption" color="textSecondary">
      {title}
    </Typography>
    <Typography>{value}</Typography>
  </Grid>
)

CustomerFinancialInformationField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
}

CustomerFinancialInformationField.defaultProps = {
  title: '',
  value: '---',
}

const CustomerFinancialInformation = () => {
  const { id: customerId } = useParams()
  const { data: customerData, isLoading } = useGetCustomerQuery({ customerId }, { skip: !customerId })
  useCustomerHeader(customerData)
  useGlobalLoader(isLoading)
  const { getPaymentTermNameById } = usePaymentTerms({})
  const gsPayContact = customerData?.contacts?.find(contact => contact.id === customerData?.gsPayContactId)

  if (isLoading) return null

  return (
    <Box p={3} data-testid="customer-finanical-information">
      <Grid container rowSpacing={2} direction="column">
        <Grid item xs={3}>
          <Typography variant="h6">Financial Information</Typography>
        </Grid>
        {gsPayContact && (
          <CustomerFinancialInformationField
            title="GreenSpark Pay Contact"
            value={`${gsPayContact?.firstName} ${gsPayContact?.lastName}`}
          />
        )}
        <CustomerFinancialInformationField
          title="Preferred Payment Method"
          value={PAYMENT_METHODS_VALUES?.[customerData?.preferredPaymentMethod]}
        />
        <CustomerFinancialInformationField
          title="Payment Terms"
          value={getPaymentTermNameById(customerData?.defaultPaymentTermId)}
        />
        <CustomerFinancialInformationField
          title="Credit Balance"
          value={
            customerData?.creditBalance?.amount ? `$${formatNumber(customerData.creditBalance.amount)}` : undefined
          }
        />
        <CustomerFinancialInformationField title="Default Currency" value={customerData?.defaultCurrency} />
        <CustomerFinancialInformationField title="Tax Number" value={customerData?.taxNumber} />
        <CustomerFinancialInformationField
          title="Tax Rate"
          value={customerData?.taxRate ? `${customerData.taxRate}%` : undefined}
        />
        <CustomerFinancialInformationField
          title="Accounting Number"
          value={customerData?.accountingNumber || undefined}
        />
      </Grid>
    </Box>
  )
}

export default CustomerFinancialInformation
